module.exports = __webpack_public_path__ + "static/media/EMPTY.36b27fae.webp";